export type MfaDuplicateCallMitigationConfigDto = {
    isOnCompleteFactoryMitigationEnabled?: boolean;
    isOnCompleteCallbackMitigationEnabled?: boolean;
    isMfaStatusCheckMitigationEnabled?: boolean;
    isLoggingEnabled?: boolean;
    isV2CheckerEnabled?: boolean;
};
export type MfaDuplicateCallMitigationConfig = Required<MfaDuplicateCallMitigationConfigDto>;

export function mapMfaDuplicateCallMitigationConfig(config?: MfaDuplicateCallMitigationConfigDto): MfaDuplicateCallMitigationConfig {
    return {
        isOnCompleteFactoryMitigationEnabled: config?.isOnCompleteFactoryMitigationEnabled || false,
        isOnCompleteCallbackMitigationEnabled: config?.isOnCompleteCallbackMitigationEnabled || false,
        isMfaStatusCheckMitigationEnabled: config?.isMfaStatusCheckMitigationEnabled || false,
        isLoggingEnabled: config?.isLoggingEnabled || false,
        isV2CheckerEnabled: config?.isV2CheckerEnabled || false,
    };
}
